import * as React from 'react';

import type { W_Material_FindForJobImport_VM_Single } from 'ab-api/web/material/findForJobImport';

import Checkbox from 'af-components/Controls/Checkbox';

import styles from './styles.module.scss';
import MaterialEntry from '../../MaterialEntry';

interface OwnProps {
	material: W_Material_FindForJobImport_VM_Single;
	toggleImport: (material: W_Material_FindForJobImport_VM_Single) => void;
}

type Props = OwnProps;

const MaterialEntryCheckable: React.FC<Props> = (props) => {
	const { material, toggleImport } = props;

	const handleCheck = React.useCallback(() => {
		toggleImport(material);
	}, [material, toggleImport]);

	return (
		<div className={styles.MaterialEntryCheckable}>
			<MaterialEntry className={styles.materialeEntry} material={material} />
			<Checkbox handleChange={handleCheck} isChecked={material.imported} />
		</div>
	);
};

export default React.memo(MaterialEntryCheckable);
